import { Experiment } from "@amplitude/experiment-js-client";
import type { ExperimentConfig } from "@amplitude/experiment-js-client/dist/types/src/config";
import React, { type ReactNode, useEffect, useMemo, useState } from "react";
import { Provider, liveContextValue, offContextValue } from "./context";

export const AmplitudeExperimentProvider = ({
	apiKey,
	children,
	...experimentConfig
}: {
	apiKey: string;
} & ExperimentConfig & { children: ReactNode }) => {
	const [value, setValue] = useState(offContextValue);

	useEffect(() => {
		const { debug } = experimentConfig;
		const client = Experiment.initializeWithAmplitudeAnalytics(
			apiKey,
			experimentConfig,
		);

		const start = async () => {
			await client.start();
			setValue(liveContextValue(client));
			if (debug) console.debug("Amplitude Experiment started.");
		};

		const stop = () => {
			client.stop();
			setValue(offContextValue);
			if (debug) console.debug("Amplitude Experiment stopped.");
		};

		start().catch(console.error);

		return stop;
	}, [apiKey]);

	return useMemo(
		() => <Provider value={value}>{children}</Provider>,
		[value, children],
	);
};
